import React, { useEffect } from "react";

const RepresentativeCard = ({ position, names }) => (
  <li id="repCardHolder">
    <div className="repCard">
      <p className="position">{position}</p>
      <h4 className="h4" style={{ textAlign: 'center' }}>{names}</h4>
    </div>
  </li>
);

function Representatives() {
  useEffect(() => {
    document.title = "Representatives";
  });
  return (
    <div className="content">
      <div className="w-container">
        <div className="page-head">
          <div className="page-title">
            <h1 className="h1">Representatives</h1>
          </div>
          <div className="flex-vert" style={{ marginTop: "-10px", marginBottom: "-40px" }}>
            <div className="sub-hrule"></div>
            <p className="paragraph-center sub">
              The Wiess Reps Program gives the people of Wiess the opportunity
              to use their individual passions and talents to serve their fellow
              Wiesspeople and make the Wiess experience even sweeter than it
              already is.
            </p>
          </div>
        </div>
        <div className="people-section">
          <div id="repsnav" className="from-navbar-ref"></div>
          <div id="reps" className="page-nav-ref"></div>
          <div class="sub-head" style={{ position: "relative", width: "100%", paddingBottom: "56.25%", height: "0", overflow: "hidden", marginBottom: "80px" }}>
            <iframe
              style={{ position: 'absolute', top: "0", left: "0", width: '100%', height: '100%' }}
              src="https://1drv.ms/p/c/e1e7a756d9790ec7/IQRgjfIEKaHzQbUukwkCH8bUAWNAHZHYTU9446JYbnKP3hY?em=2&amp;wdAr=1.7777777777777777"
              frameborder="0"
              allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"
              title="RepSlides">
            </iframe>
          </div>
          <ul className="people-grid reps w-list-unstyled">
            <RepresentativeCard
              position="Basement Rep"
              names="George Bickham"
            />
            <RepresentativeCard
              position="Birthday Reps"
              names="Jasmine Godoy, Adrian Villegas, Gabriela Catalina MacArthur, & Ioli Iliopoulou"
            />
            <RepresentativeCard
              position="Boba Reps"
              names="Maya Chan, Aoife Shannon, & Alena Powell"
            />
            <RepresentativeCard
              position="Chalkboard Reps"
              names="Claire Thacker & Sejal Patel"
            />
            <RepresentativeCard
              position="College Night Reps (Fall)"
              names="Katherine Kyles, Janaki Venepally, & Kevwe Ikeneku"
            />
            <RepresentativeCard
              position="College Night Reps (Spring)"
              names="Jonah Tontiplaphol, Xavi Gallart & Diego Terrones"
            />
            <RepresentativeCard 
              position="Computer Room Reps"
              names="David Igbekele & Eesha Surapaneni" 
            />
            <RepresentativeCard
              position="Decorations Reps"
              names="Lara Oosthuizen & Ioli Iliopoulou"
            />
            <RepresentativeCard
              position="Eco Reps"
              names="Adrian Villegas & Rosa Sabel"
            />
            <RepresentativeCard
              position="Election Reps"
              names="Molly Wladis & Nathan Chen"
            />
            <RepresentativeCard
              position="Fire Pit Reps"
              names="Sara Edelstein, Om Kulkarni, Eli Risinger, & George Bickham"
            />
            <RepresentativeCard
              position="1st Floor Reps"
              names="Maya Chan & Athena Luo"
            />
            <RepresentativeCard
              position="2nd Floor Reps"
              names="Xavi Gallart & Eli Risinger"
            />
            <RepresentativeCard
              position="3rd Floor Rep"
              names="Janaki Venepally"
            />
            <RepresentativeCard
              position="4th Floor Reps"
              names="Sergio Karam & Nathan Chen"
            />
            <RepresentativeCard
              position="Fourth Floor Balcony Reps"
              names="Jenny Karsner & Shem Brown"
            />
            <RepresentativeCard
              position="Hair Reps"
              names="Reid Waldon, Aria Johnson, Sofia Garcia, Sejal Patel, & Claire Thacker"
            />
            <RepresentativeCard
              position="International Student Ambassadors"
              names="Olivia Zhao & Sergio Rodriguez"
            />
            <RepresentativeCard
              position="Intramural Sports Reps"
              names="Aislinn Burns, Lauren Thole & Xavi Gallart"
            />
            <RepresentativeCard
              position="Kitchen Reps"
              names="Ella Scheinler & Sergio Rodriguez"
            />
            <RepresentativeCard 
              position="Laundry Room Rep" 
              names="Ben Williams"
            />
            <RepresentativeCard 
              position="Librarians" 
              names="Olivia Brazier & Jack Li"
            />
            <RepresentativeCard 
              position="Lunar New Year Reps" 
              names="Vivian Lin, Alina Zhong, & Zoe Setiadi"
            />
            <RepresentativeCard 
              position="Merch Reps" 
              names="Ethan Huang & Diana Ho" 
            />
            <RepresentativeCard 
              position="Merch Rep Apprentices" 
              names="Alice Xie, Adrian Villegas, & Olivia Brazier" 
            />
            <RepresentativeCard 
              position="Movie Room Reps" 
              names="Owen Marye, Shem Brown, & Brandon Roberts" 
            />
            <RepresentativeCard
              position="Mop & Vacuum Reps"
              names="Jun Lee & Ethan Huang"
            />
            <RepresentativeCard 
              position="Music Reps" 
              names="Xavi Gallart, Owen Marye, & Eva Poduska" 
            />
            <RepresentativeCard 
              position="PODS Reps" 
              names="Eli Risinger & Aoife Shannon" 
            />
            <RepresentativeCard
              position="Positive Affirmation Reps"
              names="David Uchime, Sara Kalra, & Aislinn Burns"
            />
            <RepresentativeCard
              position="Projector Reps"
              names="Owen Marye, Akina Damanik, & Jana Robertson"
            />
            <RepresentativeCard
              position="Rice Program Council Rep"
              names="Justine Candelaria"
            />
            <RepresentativeCard 
              position="Silly String Assassin Reps" 
              names="Rahul Santhanam, Iyad Kelifa, & Grant Wilson" 
            />
            <RepresentativeCard 
              position="Tailor Reps" 
              names="Sofija Jiotis & Srilalitha Jyosyula" 
            />
            <RepresentativeCard 
              position="Thrift Rep" 
              names="Sofia Khoury" 
            />
            <RepresentativeCard
              position="UpCo Reps"
              names="Ella Scheinler & Molly Wladis"
            />
            <RepresentativeCard
              position="Webmaster Reps"
              names="Faith Zhang & Peter Golovakov"
            />
            <RepresentativeCard
              position="Wiess Cream Reps"
              names="Sofia Garcia & Sejal Patel"
            />
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Representatives;
